const body = document.querySelector('body');
const engagementOptions = document.querySelector('.engagement-options');
const triggerOption = document.querySelectorAll('.trigger-option');
const estimatesContent = document.querySelectorAll('.option-detail');
const closeEstimate = document.querySelectorAll('.close-estimate-option');

let isOpen = false;

if(!!engagementOptions){
  triggerOption.forEach(item => {

      let itemID = item.getAttribute('id');
      let optionNum = itemID.substring(itemID.indexOf('-') + 1);
      let clickedOption = engagementOptions.querySelector("#option_" + optionNum);

      function bodyEventListener(e) {
          if (isOpen === clickedOption) {
              // check x&y clicking position
              if (!clickedOption.contains(e.target)) {
                  closeSlideIns();
              }
          }
      }

      item.addEventListener('click', function(e){
          e.stopPropagation();
          e.preventDefault();
          // item.classList.add('active');
          closeSlideIns();
          isOpen = clickedOption;
          clickedOption.classList.add('active');
          body.classList.add('scroll-lock');
      });

      body.addEventListener('click', bodyEventListener);
  });
  // close estimate
  closeEstimate.forEach(item => {
      item.addEventListener('click', function(){
          closeSlideIns();
      });
  });
  // closes option with escape key
  document.addEventListener('keydown', function(event){
      if(event.key === "Escape"){
          closeSlideIns();
      }
  });
}

function closeSlideIns() {
    estimatesContent.forEach(option => {
        option.classList.remove('active');
    });
    body.classList.remove('scroll-lock');
    isOpen = false;
}
